// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		suggestionPosition: 'right',
		suggestionMobileStyle: 'style2',
	}
};

(function () {  // Add this

	BoostPFS.inject(this);  // Add this
	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
		if (jQ(searchBoxId).closest('.search_container').length > 0) {
			this.setSuggestionWidth(searchBoxId, 400);
		}
	};
    InstantSearchApi.beforeCall = function(searchTerm) {
        Globals.instantSearchQueryParams.currency = boostPFSConfig.general.current_currency.toLowerCase();
        Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
        Globals.instantSearchQueryParams.return_all_currency_fields = false;
    }
})();  // Add this at the end